import request from '@/utils/request';
import api from "./interface";
import * as AES from "@/utils/aes.js";
export function login(data) {
  var params = JSON.parse(JSON.stringify(data));
  params.phone = AES.encryptAES(params.phone);
  params.password = AES.encryptAES(params.password);
  params.security = 1;
  return request({
    url: api.INTERFACE_LOGIN,
    method: 'post',
    data: params
  });
}
export function loginByTicket(data) {
  console.log(data);
  return request({
    url: api.INTERFACE_LOGIN_BY_TICKET,
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: api.INTERFACE_GET_USER,
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: api.INTERFACE_LOGIN_OUT,
    method: 'post'
  });
}